import { useState, useEffect } from "react";
import axios from "axios";
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ProductCarousel = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${API}/products`);
        setProducts(res.data);
      } catch {
        setProducts([
          { id: "majestic", name: "Sartaj Majestic Basmati Rice", tagline: "The Crown Jewel", description: "", image: "" },
          { id: "diabetic", name: "Sartaj Diabetic Basmati Rice", tagline: "Wellness Redefined", description: "", image: "" },
          { id: "marriage_special", name: "Sartaj Marriage Special Basmati Rice", tagline: "Celebrate in Grandeur", description: "", image: "" },
          { id: "sella_parboiled", name: "Sartaj Sella Parboiled Basmati Rice", tagline: "Golden Perfection", description: "", image: "" },
          { id: "persian_style", name: "Sartaj Shomal Persian Style Basmati Rice", tagline: "Persian Elegance", description: "", image: "" },
          { id: "super_sella", name: "Sartaj Super Sella Deradooni Rice", tagline: "Everyday Luxury", description: "", image: "" },
        ]);
      }
    };
    fetchProducts();
  }, []);

  return (
    <section
      id="collection"
      data-testid="product-carousel-section"
      className="py-24 md:py-32 bg-brand-bg-light"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="text-center mb-16 space-y-4">
          <p className="text-xs uppercase tracking-[0.3em] font-body font-semibold text-brand-gold">
            Our Range
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-brand-primary">
            Our Premium <span className="italic">Varieties</span>
          </h2>
          <div className="w-16 h-[1px] bg-brand-gold mx-auto" />
        </div>

        {/* Carousel */}
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          plugins={[
            Autoplay({
              delay: 3000,
              stopOnInteraction: false,
              stopOnMouseEnter: true,
            }),
          ]}
          className="w-full"
          data-testid="product-carousel"
        >
          <CarouselContent className="-ml-6">
            {products.map((product) => (
              <CarouselItem
                key={product.id}
                className="pl-6 basis-full sm:basis-1/2 lg:basis-1/3"
              >
                <div
                  className="product-card group border border-brand-primary/10 bg-brand-bg-light overflow-hidden"
                  data-testid={`product-card-${product.id}`}
                >
                  {/* Image */}
                  <div className="relative h-72 overflow-hidden bg-brand-primary/5 flex items-center justify-center">
                    {product.image ? (
                      <img
                        src={product.image}
                        alt={product.name}
                        className="product-card-img w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-brand-primary/5">
                        <span className="font-heading text-2xl text-brand-primary/20 italic">
                          Image Coming Soon
                        </span>
                      </div>
                    )}
                    <div className="absolute inset-0 bg-brand-primary/0 group-hover:bg-brand-primary/10 transition-colors duration-500" />
                  </div>

                  {/* Info */}
                  <div className="p-6 space-y-3">
                    <p className="text-[10px] uppercase tracking-[0.3em] text-brand-gold font-body font-semibold">
                      {product.tagline}
                    </p>
                    <h3 className="font-heading text-xl font-medium text-brand-primary leading-tight">
                      {product.name}
                    </h3>
                    {product.description && (
                      <p className="text-sm font-body font-light text-brand-text-dark/60 line-clamp-2">
                        {product.description}
                      </p>
                    )}
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious
            data-testid="carousel-prev"
            className="hidden md:flex -left-6 border-brand-gold/30 text-brand-gold hover:bg-brand-gold hover:text-brand-primary"
          />
          <CarouselNext
            data-testid="carousel-next"
            className="hidden md:flex -right-6 border-brand-gold/30 text-brand-gold hover:bg-brand-gold hover:text-brand-primary"
          />
        </Carousel>
      </div>
    </section>
  );
};

export default ProductCarousel;
